import React, { Component } from 'react';
import MailHeader from './../components/mailHeader';
import { connect } from 'react-redux';
import './../app.scss';

class MailHeaderContainer extends Component {

    getNumberOfUnreadMails = (mails) => {
        let readMails = this.getTotalMails(mails).filter(mail => this.getMailReadFlag(mail.actionThread));
        return (this.getTotalMails(mails).length - readMails.length);
    }

    getMailReadFlag = (actionThread) => {
        return actionThread.find((action) => action.type === 'mail_read')
    }

    getMailShownFlag = (mail, actionThread) => {
        return actionThread.find((action) => action.type === 'isShown')
    }

    getMailStarredFlag = (actionThread) => {
        return actionThread.find((action) => action.type === 'starred' && action.status === true)
    }

    getTotalMails = (mails) => {
        return mails.filter(mail => mail.isPrimary && mail.type !== "call" && mail.type !== "meeting" && this.getMailShownFlag(mail, mail.actionThread));
    }

    isSentMailPresent = (mail) => {
        const { actionThread } = mail;
        return actionThread.some((action) => (action.type === "compose"));
    }

    getCurrentMails = (mails) => {
        let { match } = this.props;

        if (match.url === "/mails/starred") {
            return this.getTotalMails(mails).filter(mail => this.getMailStarredFlag(mail.actionThread))
        } else if (match.url === "/mails/attachments") {
            return this.getTotalMails(mails).filter(mail => mail.attachments)
        } else if (match.url === "/mails/sent") {
            return this.getTotalMails(mails).filter(mail => this.isSentMailPresent(mail));
        } else {
            return this.getTotalMails(mails)
        }
    }

    getSelectedTab = () => {
        let { match } = this.props;
        switch (match.url) {
            case '/mails/sent': return 2;
            case '/mails/starred':
            default: return 1;
        }
    }

    render() {
        const { mails, match, isMailThreadView, uiState } = this.props;
        return <MailHeader
            {...this.props}
            unreadMails={this.getNumberOfUnreadMails(mails)}
            totalMails={this.getTotalMails(mails).length}
            currentMails={this.getCurrentMails(mails).length}
            selectedTab={this.getSelectedTab()}
            match={match}
            isMailThreadView={isMailThreadView}
            currentMailIndex={uiState.currentMail.index}
        />
    }
}

const mapStateToProps = (state) => {
    return { mails: state.mails, uiState: state.uiState };
};

export default connect(mapStateToProps)(MailHeaderContainer);



// WEBPACK FOOTER //
// /src/containers/mailHeaderContainer.js